
// import BrowserDatabase from "SourceUtil/BrowserDatabase/BrowserDatabase";
import { showNotification } from 'SourceStore/Notification/Notification.action';
import AdminCustomerQuery from '../../query/AdminCustomerQuery';
import { fetchQuery } from 'SourceUtil/Request';
import { getCustomersList, getOrdersList as UpdateOrderList, updateIsLoading } from './AdminCustomer.action';

export class AdminCustomerDispatcher {

    getData(dispatch, { currentPage, type, fieldsToSearch } ) {
        dispatch(updateIsLoading(true));

        if(type === 'orders') {
         return this.getOrdersList(dispatch, { currentPage, fieldsToSearch });
        }

        return this.getCustomerList(dispatch, { currentPage, fieldsToSearch });
    }

    getCustomerList = (dispatch, { currentPage, fieldsToSearch }) => {
        const query = AdminCustomerQuery.getCustomerSearchQuery({ currentPage, fieldsToSearch });
        return fetchQuery(query).then(
            ({ search_customers }) => {
                dispatch(getCustomersList(search_customers))
                dispatch(updateIsLoading(false));
            },
            (error) => dispatch(showNotification('error', __(error ? error[0].message : 'unable to get customer data!')))
        );
    }

    getOrdersList = (dispatch, { currentPage, fieldsToSearch }) => {
        const query = AdminCustomerQuery.getOrderListSearchQuery({ currentPage, fieldsToSearch });

        return fetchQuery(query).then(({ search_orders }) => {
                dispatch(UpdateOrderList(search_orders));
                dispatch(updateIsLoading(false));
                },
            (error) => dispatch(showNotification('error', __(error ? error[0].message : 'unable to get order data!')))
            );
    }

}

export default new AdminCustomerDispatcher()
